import Card from '@/components/elements/Card';
import ContactButton from '@/components/ContactButton';

interface LandingHeroProps {
  content: {
    title: string;
    subtitle?: string;
    description?: string;
    callToAction?: boolean;
    cards?: Array<{
      title: string;
      icon: React.FC;
      description: string;
    }>;
  };
  className?: string;
}

function LandingHero({ content, className = '' }: LandingHeroProps) {
  return (
    <section className={`bg-[#fafafa] overflow-hidden relative py-[48px] md:py-[62px] ${className}`}>
      <div className='px-4 md:container mx-auto flex flex-col items-center'>
        <h1
          className='z-20 text-[2.8rem]/[2.9rem] md:text-[3.25rem]/[3.4rem] max-w-[1040px] text-center'
          dangerouslySetInnerHTML={{ __html: content.title }}
        />

        {content.subtitle && <h2 className='mt-8'>{content.subtitle}</h2>}

        {content.description && (
          <p className='z-20 text-[1rem]/5 md:text-[1.2rem]/6 text-center font-light max-w-[830px]'>
            {content.description}
          </p>
        )}

        {content.callToAction && <ContactButton className='z-20 mt-5 md:mt-6' />}

        {content.cards && (
          <div className='z-20 w-full mt-8 md:mt-10 flex flex-col gap-4 md:grid md:grid-cols-3 lg:gap-6 xl:gap-8'>
            {content.cards.map((card, index) => {
              const IconComponent = card.icon;
              return (
                <Card
                  key={index}
                  title={card.title}
                  background='white'
                  icon={<IconComponent />}
                  description={card.description}
                />
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}

export default LandingHero;
